// External Imports
import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

// Internal Imports
import { getRouteKey } from './index.js';

// Local Functions
const getContentArchiveBase = createSelector(
  [getRouteKey, get('archive')],
  (routeKey, archiveState) => archiveState[routeKey],
);

// Module Exports
export { getContentArchiveBase };
